import { render, staticRenderFns } from "./FiltersSection.vue?vue&type=template&id=088be1ba&scoped=true"
import script from "./FiltersSection.vue?vue&type=script&lang=js"
export * from "./FiltersSection.vue?vue&type=script&lang=js"
import style0 from "./FiltersSection.vue?vue&type=style&index=0&id=088be1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088be1ba",
  null
  
)

export default component.exports